import { useDispatch } from "react-redux";
import { addToast } from "@/store/slices/uiSlice";

interface ToastProps {
  title?: string;
  description?: string;
  variant?: "default" | "destructive";
}

export const toast = ({ title, description, variant }: ToastProps) => {
  // This is a standalone toast function for non-React contexts
  console.log(`Toast: ${title} - ${description}`);
};

export const useToast = () => {
  const dispatch = useDispatch();

  const toast = ({ title, description, variant }: ToastProps) => {
    const message = title
      ? `${title}${description ? `: ${description}` : ""}`
      : description || "";
    dispatch(
      addToast({
        type: variant === "destructive" ? "error" : "success",
        message,
      }),
    );
  };

  return { toast };
};
